import './creatives-preview.scss';

import groupBy from 'lodash/groupBy';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import { arrayOf, bool, func, number, objectOf } from 'prop-types';
import React from 'react';
import { GoX } from 'react-icons/go';
import { Card, CardFooter } from 'reactstrap';

import { campaignLineCreativeShape, creativeShape } from '../../prop-types';
import CreativeCardImage from '../CreativeCardImage';
import CreativesMediaSet from '../CreativesMediaSet/CreativesMediaSet';
import { getSizeType } from '../utils';

function getMediaSets(enrichedCampaignLineCreatives) {
  const sets = groupBy(
    enrichedCampaignLineCreatives,
    ({ creative }) => creative.mediaSet,
  );
  return sortBy(Object.entries(sets), ([setName]) => setName);
}

function CreativesPreview({
  creativesById,
  campaignLineCreatives,
  removeCreativeAssociation,
  productId,
  readOnly,
}) {
  if (isEmpty(campaignLineCreatives)) return null;

  const enrichedCampaignLineCreatives = campaignLineCreatives
    .map(({ creativeId, ...rest }) => ({
      ...rest,
      creative: creativesById[creativeId],
    }))
    .filter(({ creative }) => creative);

  const mediaSets = getMediaSets(enrichedCampaignLineCreatives);
  return (
    <div className="mt-3 d-flex overflow-auto">
      {mediaSets.map(([setName, setCreatives]) => {
        return (
          <CreativesMediaSet
            compact
            key={setName}
            className="mr-2 flex-shrink-0"
            name={setName}
          >
            <ul className="creatives-preview list-unstyled list-inline mb-0">
              {setCreatives.map(({ creative, id, campaignLineId }) => {
                const onClick = () =>
                  removeCreativeAssociation(campaignLineId, id);
                return (
                  <li className="list-inline-item" key={id}>
                    <Card>
                      {!readOnly && (
                        <GoX className="remove-btn" onClick={onClick} />
                      )}
                      <CreativeCardImage creative={creative} top />
                      <CardFooter className="px-2 py-1 bg-white text-muted small text-center">
                        {getSizeType(creative, productId)}
                      </CardFooter>
                    </Card>
                  </li>
                );
              })}
            </ul>
          </CreativesMediaSet>
        );
      })}
    </div>
  );
}

CreativesPreview.propTypes = {
  creativesById: objectOf(creativeShape.isRequired).isRequired,
  campaignLineCreatives: arrayOf(campaignLineCreativeShape.isRequired)
    .isRequired,
  removeCreativeAssociation: func.isRequired,
  productId: number.isRequired,
  readOnly: bool.isRequired,
};

export default CreativesPreview;
